import { render, staticRenderFns } from "./iconNoProduct.vue?vue&type=template&id=b0264d86&scoped=true"
import script from "./iconNoProduct.vue?vue&type=script&lang=js"
export * from "./iconNoProduct.vue?vue&type=script&lang=js"
import style0 from "./iconNoProduct.vue?vue&type=style&index=0&id=b0264d86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0264d86",
  null
  
)

export default component.exports